import { Component, OnInit } from '@angular/core';
import {RulesService} from '../../rules.service';
import { Location } from '@angular/common';
import {Router} from '@angular/router';
import {RuleModel} from '../../model/RuleModel';
import {FormControl, Validators} from '@angular/forms';
import {SpinnerService} from '../../../core/spinner/spinner.service';
import {NotificationBarService} from '../../../core/notify/notification.service';
import {NotificationType} from '../../../core/notify';
import {PageCanDeactivate} from '../../common/can-deactivate/can-deactivate-page';

@Component({
  selector: 'app-save-rule',
  templateUrl: './save-rule.component.html',
  styleUrls: ['./save-rule.component.scss']
})
export class SaveRuleComponent  extends PageCanDeactivate implements OnInit {
  rule: RuleModel;
  name: FormControl;
  description: FormControl;
  isSubmitted: boolean;
  constructor(private ruleService: RulesService,
              private router: Router,
              private spinner: SpinnerService,
              private notifier: NotificationBarService,
              private location: Location) { super(); }

  ngOnInit() {
    this.ruleService.toRuleModel();
    this.rule = this.ruleService.getRuleModel();
    this.setForm(this.rule);
    if (!this.rule) {
      this.router.navigate([`/rules/new/step-1`]);
      return;
    }
  }
  get hasChanges(): boolean{
    return !!this.rule;
  }
  get ruleId() {
    if (this.rule && this.rule.id) {
      return `${this.rule.id}/edit`;
    }
    return 'things/new';
  }
  get action() {
    return this.ruleService.getActionList()[0];
  }

  goToFirstStep() {
    this.setNameAndDescription()
    this.router.navigate([`rules/${this.ruleId}/step-2`]);
  }
  back() {
    this.setNameAndDescription();
    this.location.back();
  }
  save() {
    if (!this.name.valid) {
      this.isSubmitted = true;
      return;
    }
      this.spinner.show();
      if (!this.rule.id) {
        this.ruleService.saveRule(this.name.value, this.description.value)
          .subscribe((res) => {
            this.spinner.hide();
            this.notifier.create({message: 'Rule has been created successfully', type: NotificationType.Success});
            this.router.navigate(['rules/list']);
          }, error => this.spinner.hide());
      } else {
        this.ruleService.updateRule(this.name.value, this.description.value)
          .subscribe((res) => {
            this.spinner.hide();
            this.notifier.create({message: 'Rule has been updated successfully', type: NotificationType.Success});
            this.router.navigate(['rules/list']);
          }, error => this.spinner.hide());
      }

  }

  setForm(rule) {
    let name, description;
    if (this.rule && this.rule.name) {
      name = this.rule.name;
    }
    if (this.rule && rule.description) {
      description = this.rule.description;
    }
   this.name = new FormControl(name, [Validators.required, Validators.maxLength(50)]);
   this.description = new FormControl(description, Validators.maxLength(200));
  }

  private setNameAndDescription () {
    this.ruleService.getRuleModel().name = this.name.value;
    this.ruleService.getRuleModel().description = this.description.value;
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/new-rule/save-rule/save-rule.component.ts